var level2Task0 = `
<xml xmlns="https://developers.google.com/blockly/xml" id="workspaceBlocks" style="display: none">
  <variables>
    <variable id="Pv^77Ftj7=%B*5J1pqo,">my_name</variable>
  </variables>
  <block type="variables_set" id="O;]jC]cEr{fP|]#6zdPQ" x="12" y="38">
    <field name="VAR" id="Pv^77Ftj7=%B*5J1pqo,">my_name</field>
    <value name="VALUE">
      <block type="text" id="3Fr!tx+jx?z6PIaRvc#D">
        <field name="TEXT">Example Name</field>
      </block>
    </value>
    <next>
      <block type="text_print" id="$OHr(BtV@-*vsH)^%zPF">
        <value name="TEXT">
          <block type="variables_get" id="KrHC8=p#B;}_q!=w!{U">
            <field name="VAR" id="Pv^77Ftj7=%B*5J1pqo,">my_name</field>
          </block>
        </value>
      </block>
    </next>
  </block>
</xml>
`
export default level2Task0 